import { render, staticRenderFns } from "./CompanyEventListItem.vue?vue&type=template&id=b35a898e&scoped=true"
import script from "./CompanyEventListItem.vue?vue&type=script&lang=js"
export * from "./CompanyEventListItem.vue?vue&type=script&lang=js"
import style0 from "./CompanyEventListItem.vue?vue&type=style&index=0&id=b35a898e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35a898e",
  null
  
)

export default component.exports